import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  getBranches,
  getEntities,
  getFlowNodes,
  getFlowDeletionStatus,
} from 'js/reducers/pipeline/selectors';

export type FlowDeletionStatus = {
  canDelete: boolean;
  hasActiveResources: boolean;
  reason: string | null;
};

type UseFlowDeletionStatusReturn = {
  getFlowDeletionStatus: (flowNodeId: number) => FlowDeletionStatus;
};

export function useFlowDeletionStatus(): UseFlowDeletionStatusReturn {
  const entities = useSelector(getEntities);
  const branches = useSelector(getBranches);
  const flowNodes = useSelector(getFlowNodes);

  const _getFlowDeletionStatus = useCallback(
    (flowNodeId: number) => {
      return getFlowDeletionStatus(flowNodeId, {
        entities,
        branches,
        flowNodes,
      }) as FlowDeletionStatus;
    },
    [entities, branches, flowNodes],
  );

  return {
    getFlowDeletionStatus: _getFlowDeletionStatus,
  };
}
